/**
 * Which locked solutions hold up across the runs (#946, slice 7). Pure.
 *
 *   holds       — realised or merely delayed in every finished run
 *   failsAll    — fails in every run: the strongest signal in the table
 *   fails       — fails in at least one run (named, because that is the risk)
 *   varies      — anything else: it does less in some world than in another
 *
 * Only finished runs count; a run without a fate for a solution says nothing
 * about it, so the solution is judged on the runs that do.
 */
const HOLDS = new Set(['realised', 'delayed']);

export function robustness(solutionIds, timelines) {
  const runs = timelines.filter((t) => t.status === 'done');
  return solutionIds.map((id) => {
    const cells = runs.map((t) => ({ timelineId: t.id, fate: t.fates.find((f) => f.solutionId === id) || null }));
    const fates = cells.map((c) => c.fate?.fate).filter(Boolean);
    let verdict = 'unknown';
    if (fates.length) {
      if (fates.every((f) => f === 'failed')) verdict = 'failsAll';
      else if (fates.includes('failed')) verdict = 'fails';
      else if (fates.every((f) => HOLDS.has(f))) verdict = 'holds';
      else verdict = 'varies';
    }
    return { solutionId: id, cells, verdict, failsIn: cells.filter((c) => c.fate?.fate === 'failed').map((c) => c.timelineId) };
  });
}
